




























import { UseTabs } from "@/common/composition/use-tabs";
import { SharedState } from "@/common/state";
import SimpleNavTabs from "@/components/SimpleNavTabs.vue";
import { computed, onMounted } from "@vue/composition-api";
import Vue from "vue";
import EventJustificationPolicy from "./ask-for-justification/EventJustificationPolicy.vue";
import MassDownloadsPolicy from "./mass-download/MassDownloadsPolicy.vue";
import RiskyUsersPolicy from "./risky-users/RiskyUsersPolicy.vue";
export default Vue.extend({
  components: {
    SimpleNavTabs,
    RiskyUsersPolicy,
    EventJustificationPolicy,
    MassDownloadsPolicy,
  },
  setup(_, { root: { $router } }) {
    const [tabs, current_tab, set_current_tab] = UseTabs(
      [
        {
          id: "downloads-anomalies",
          name: "Download Anomalies",
          // icon: "DownloadAnomaliesPolicy",
        },
        {
          id: "event-justification",
          name: "Automate Event Justification Requests",
          // icon: "Label",
        },
        {
          id: "risky-users",
          name: "Educate Risky Users",
          // icon: "RiskyUsersPolicy",
        },
      ],
      0
    );

    onMounted(() => {
      if (SharedState.is_biz_user.value) {
        $router.replace("/");
        return;
      }
    });
    return {
      tabs,
      current_tab,
      set_current_tab,
      is_feature_policy_enabled: computed(() => {
        return SharedState.FeatureHelper.is_enabled("educate_risky_users");
      }),
    };
  },
});
